export const MAX_LABELS_TO_PRINT = 100;
